import VMosaic from './VMosaic.vue';

export { VMosaic };
export default VMosaic;
